module.exports = __webpack_public_path__ + "img/Wing_feathers_Normal.02e331b.png";